import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useSYS4110_R01Store } from "./Store_SYS4110_R01";
import { Calendar_SYS4110_R01 } from "./Calendar_SYS4110_R01";
import { EventModal_SYS4110_R01 } from "./EventModal_SYS4110_R01";
import { Content_SYS4110_R01 } from "./Content_SYS4110_R01";
import { SearchSection_SYS4110_R01 } from "./SearchSection_SYS4110_R01";
import useUiuxStore from "src/store/useUiuxStore";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";

// 메인 캘린더 영역 컴포넌트
interface CalendarSectionProps {
  onDateClick: (date: Date) => void;
  onEventClick: (event: any) => void;
}

const CalendarSection: React.FC<CalendarSectionProps> = ({
  onDateClick,
  onEventClick
}) => (
  <div className="flex-1 flex flex-col overflow-hidden p-4 min-h-0 ">
    <Calendar_SYS4110_R01
      onDateClick={onDateClick}
      onEventClick={onEventClick}
    />
  </div>
);

export const Container_SYS4110_R01 = () => {
  const {
    selectedEvent,
    isEventModalOpen,
    selectedCompCd,
  } = useSYS4110_R01Store();

  const { setMessage } = useUiuxStore();

  // 권한 체크
  useFetchActionbarAuth('SYS4110_R01');

  const {
    handleFetchEvents,
	initContainerData,
    handleCreateEvent,
    handleUpdateEvent,
    handleDeleteEvent,
    handleEventClick,
    handleDateClick,
    handleCreateButtonClick,
    handleModalClose,
    handleExcelExport,
    handlePrintClick,
    handleCompCdChange,
  } = Content_SYS4110_R01({ 
	setMessage,
});

  return (
    <div className="content-container h-full flex flex-col">
      {/* 액션바 */}
      <Actionbar
        onFetchClick={handleFetchEvents}
        onCreateClick={handleCreateButtonClick}
        onDeleteClick={() => {}}
        onSaveClick={() => {}}
        onPrintClick={handlePrintClick}
        onExcelClick={handleExcelExport}
        onInitClick={initContainerData}
      />

      {/* 캘린더 헤더 */}
      <SearchSection_SYS4110_R01
        onCreateButtonClick={handleCreateButtonClick}
        onCompCdChange={handleCompCdChange}
        defaultCompCd={selectedCompCd}
      />

      {/* 메인 캘린더 영역 */}
      <CalendarSection
        onDateClick={handleDateClick}
        onEventClick={handleEventClick}
      />

      {/* 이벤트(휴일) 모달 */}
      <EventModal_SYS4110_R01
        isOpen={isEventModalOpen}
        onClose={handleModalClose}
        onSave={handleCreateEvent}
        onUpdate={handleUpdateEvent}
        onDelete={handleDeleteEvent}
        event={selectedEvent}
      />

      {/* 메시지 */}
      <Message />
    </div>
  );
};
